import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "status", "statusLoading", "statusSuccess", "statusError", "statusErrorMessage", "validation", "submitButton"]
  static values = { 
    validateUrl: String,
    debounceMs: { type: Number, default: 500 }
  }
  connect() {
    this.debounceTimer = null
    this.lastValidatedUrl = null
    
    // Validate on connect if there's already a value in the input
    if (this.hasUrlTarget && this.urlTarget.value.trim() !== "") {
      this.validate()
    }
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  validate() {
    const url = this.urlTarget.value.trim()
    
    if (this.debounceTimer) clearTimeout(this.debounceTimer)

    if (url === "") {
      this.updateStatus("", true)
      this.setValidationStatus("")
      return
    }

    if (url === this.lastValidatedUrl) return

    this.updateStatus("loading")
    this.setValidationStatus("")
    this.debounceTimer = setTimeout(() => this.performValidation(url), this.debounceMsValue)
  }

  async performValidation(url) {
    try {
      const response = await fetch(this.validateUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ video_url: url })
      })

      const data = await response.json()

      if (response.ok && data.valid) {
        this.updateStatus("success")
        this.setValidationStatus(true)
        this.lastValidatedUrl = url
      } else {
        this.updateStatus("error", false, data.error || "Invalid video URL")
        this.setValidationStatus(false)
        this.lastValidatedUrl = null
      }
    } catch (error) {
      this.updateStatus("error", false, "Unable to validate video URL")
      this.setValidationStatus(false)
      this.lastValidatedUrl = null
    }
  }

  updateStatus(type, hidden = false, message = "") {
    // Hide all status elements first
    this.hideAllStatusElements()
    
    if (hidden || type === "") {
      this.statusTarget.classList.add("hidden")
      this.enableSubmitButton()
      return
    }

    // Show the main status container
    this.statusTarget.classList.remove("hidden")

    // Show the appropriate status element and set message if needed
    switch (type) {
      case "loading":
        this.statusLoadingTarget.classList.remove("hidden")

        this.disableSubmitButton()
        break
      case "success":
        this.statusSuccessTarget.classList.remove("hidden")

        this.enableSubmitButton()
        break
      case "error":
        this.statusErrorTarget.classList.remove("hidden")

        this.enableSubmitButton()
        if (message) {
          this.statusErrorMessageTarget.textContent = message
        }
        break
    }
  }

  hideAllStatusElements() {
    this.statusLoadingTarget.classList.add("hidden")
    this.statusSuccessTarget.classList.add("hidden")
    this.statusErrorTarget.classList.add("hidden")
  }

  setValidationStatus(status) {
    if (this.hasValidationTarget) {
      this.validationTarget.value = status
    }
  }

  disableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }

  enableSubmitButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
    }
  }
}
